import { z } from 'zod'
import { EmailAddressSchema, UrlSchema } from './property.models.ts'
import { UuidSchema } from './unique-id.models.ts'

export const WorkrampWebhookPayloadSchema = z.object({
  id: UuidSchema.nullable(),
  eventType: z.enum([
    'contentCompletion.certification',
    'contentCompletion.guide',
    'contentCompletion.path',
    'contentCompletion.scorm',
    'contentEnrollment.certification',
    'contentEnrollment.guide',
    'contentEnrollment.path',
    'contentEnrollment.scorm',
    'userRegistration',
  ]),
  timestamp: z.number(),
  user: z.object({
    id: UuidSchema.nullable(),
    email: EmailAddressSchema,
    firstName: z.string(),
    lastName: z.string(),
    customAttributes: z.object({}),
    segments: z.string().array(),
  }),
  certification: z.object({
    certificate: z.object({
      certificateID: z.string().nullable(),
      expiresAt: z.number().nullable(),
      issuedAt: z.number().nullable(),
      validateUrl: UrlSchema.nullable(),
    }),
    id: UuidSchema.nullable(),
    name: z.string().nullable(),
    url: z.string(),
  }),
})
